"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncreasingArrayGenerator = void 0;
const IncreasingArrayGenerator = (size, startNumber = 0) => {
    return Array.from({ length: size }, (_, index) => startNumber + index);
};
exports.IncreasingArrayGenerator = IncreasingArrayGenerator;
